module.exports = __webpack_public_path__ + "img/highlight_on_icon.8fd03c96.svg";